<template>
  <transition name="fade">
    <div v-if="showPopup" id="notify-popup-wrap">
      <div class="event-text-wrap">
        <div class="title">
          <img class="image" :src="imageLink" />
          <span class="label">
            {{ titleLabelTranslation }}
          </span>
        </div>
        <p v-if="message" class="message">
          {{ $t(message) }}
        </p>
      </div>
      <div v-if="hasEvent" class="event-btn-wrap">
        <span class="event-btn" @click="emmitEvent">
          {{ $t(event.label) }}
        </span>
      </div>
      <span @click="hideNotifyPopup">
        <or-icon
          class="close-btn"
          icon="close"
        />
      </span>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import KnowledgeBus from '@/KnowledgeBus'

export default {
  created () {
    KnowledgeBus.$on('notifications-popup::close', this.hideNotifyPopup)
  },

  beforeDestroy () {
    KnowledgeBus.$off('notifications-popup::close', this.hideNotifyPopup)
  },

  data () {
    return {
      titleLabel: '',
      type: '',
      message: '',
      imageLink: '',
      event: '',
      showPopup: false
    }
  },

  computed: {
    ...mapState('knowledgebase/notifications', ['notifications']),

    hasEvent () {
      return !_.isEmpty(_.get(_.head(this.notifications), 'event.id', ''))
    },

    titleLabelTranslation () {
      const titleLabel = this.titleLabel
      if (Array.isArray(titleLabel)) {
        return this.$t(...titleLabel)
      }
      return this.$t(titleLabel)
    }
  },

  methods: {
    hideNotifyPopup () {
      this.titleLabel = ''
      this.type = ''
      this.message = ''
      this.showPopup = false
    },

    emmitEvent () {
      KnowledgeBus.$emit(`${this.event.id}`, this.event.param)
      this.hideNotifyPopup()
    }
  },

  watch: {
    notifications: {
      async handler (value, prev) {
        if (value.length > prev.length) {
          this.showPopup = false
          this.$nextTick(() => {
            ({
              titleLabel: this.titleLabel,
              msgLabel: this.message,
              type: this.type,
              imageLink: this.imageLink,
              event: this.event
            } = _.head(this.notifications))
            this.showPopup = true
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter {
  transform: translateY(32px);
  opacity: 0;
}

.fade-enter-active {
  transition: all 0.4s;
}

#notify-popup-wrap {
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: $sp-5;
  right: $sp-6;
  width: 512px;
  min-height: 60px;
  padding: $sp-3;
  background-color: $or-white;
  box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.08);
  font-size: 12px;
  color: $or-black-blue;
  border-radius: 4px;
  z-index: 999;
  line-height: 18px;

  .event-text-wrap {
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: scroll;

    .title {
      display: flex;
      flex-grow: 1;
    }

    .message {
      margin-top: 8px;
    }
  }

  .event-btn-wrap {
    padding: 0 0 0 $sp-3;

    .event-btn {
      color: $or-blue;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .image {
    width: 20px;
    height: 20px;
    margin-right: $sp-3;
  }

  .label {
    flex-grow: 1;
  }

  .close-btn {
    font-size: 16px;
    color: darken($or-grey, 20%);
    transition: all 0.2s ease;
    cursor: pointer;
  }
}
</style>
